// Cuenta regresiva de entrega de SRJ (hora de Uruguay), compartida por la ficha (srj-ficha.js) y el carrito (srj-carrito.js).
// Reglas de Ronald (17/10/2026): lunes a viernes en el día comprando antes de las 12; sábados en el día comprando antes de
// las 10; domingos no se entrega. El número aparece recién en las últimas 4 horas antes del corte.
// window.srjEntrega() devuelve { texto, avance } (avance en %, desde el último corte hasta el próximo).
(function () {
  var CORTE = { 1: 12, 2: 12, 3: 12, 4: 12, 5: 12, 6: 10 };
  var MONTE = ' (Solo Montevideo y alrededores)';
  var UMBRAL = 4 * 3600;
  var horaUY = function () {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Montevideo', weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' })
      .formatToParts(window.srjAhora ? window.srjAhora() : new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { dia: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), seg: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second) };
  };
  window.srjEntrega = function () {
    var a = horaUY(), dia = a.dia, seg = a.seg, frase, restante;
    if (CORTE[dia] && seg < CORTE[dia] * 3600) {
      restante = CORTE[dia] * 3600 - seg;
      frase = restante <= UMBRAL ? 'Llega hoy comprando dentro de las próximas XX' : 'Comprá ahora y te llega hoy';
    } else {
      // próximo día de entrega y su hora de corte
      var k = 1, d = (dia + 1) % 7;
      while (!CORTE[d]) { k++; d = (d + 1) % 7; }
      restante = (k - 1) * 86400 + (86400 - seg) + CORTE[d] * 3600;
      // el domingo se nombra el día ("el lunes"): pasada la medianoche del sábado, "mañana" se entiende como domingo
      var cuando = k === 1 && dia !== 0 ? 'mañana' : 'el ' + ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'][d];
      frase = restante <= UMBRAL ? 'Llega ' + cuando + ' comprando dentro de las próximas XX' : 'Comprá ahora y te llega ' + cuando;
    }
    var h = Math.floor(restante / 3600), m = Math.floor((restante % 3600) / 60);
    var plazo = h + ' ' + (h === 1 ? 'hora' : 'horas') + ' y ' + m + ' ' + (m === 1 ? 'minuto' : 'minutos');
    // la barra avanza desde el último corte hasta el próximo (siempre visible)
    var desde, kk = 0, dd = dia;
    if (CORTE[dia] && seg >= CORTE[dia] * 3600) {
      desde = seg - CORTE[dia] * 3600;
    } else {
      do { kk++; dd = (dd + 6) % 7; } while (!CORTE[dd]);
      desde = seg + (kk - 1) * 86400 + (86400 - CORTE[dd] * 3600);
    }
    return { texto: frase.replace('XX', plazo) + MONTE, avance: Math.max(3, Math.min(100, desde / (desde + restante) * 100)) };
  };
})();
